var gbb_custom_card_ext = document.createElement("script");
gbb_custom_card_ext.setAttribute("src", "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.6.4/jquery.min.js");
document.body.appendChild(gbb_custom_card_ext);
gbb_custom_card_ext.addEventListener("load", () => {
  

  function updateCart(){
    var url_with_perameter = new URL(window.location.href);
    var urlpathname = url_with_perameter.pathname;
    var builderId = urlpathname.split("/").pop();
    var dynamicVari = "giftbox_temp_cart_"+builderId; 
    var existingEntries = JSON.parse(localStorage.getItem(dynamicVari) || '[]');
    const updateObject = (keyName, newVal, object) => {
      for (var key in object) {
        if (key === keyName) {
          object[key] = newVal;
        } else {
          if(typeof object[key] === "object"){
            object[key] = updateObject(keyName, newVal, object[key]);
          }
        }
      }
      return object;
    };
    var temp_cart_data = [];
    var temp_card_data = [];
    $(existingEntries).each(function (index, value) {
        Object.values(value).forEach(function(sub_value, sub_index) {
            if(typeof sub_value === 'object' && sub_value !== null){
                var obj_key = Object.keys(value)[sub_index];
                if(obj_key.split("_").pop() ==3){
                    Object.values(sub_value).forEach(function(sec_sub_value, sec_sub_index) { 

                        var imageInput = $('[name="select_gift_images"]:checked').val();
                        var imageName = $('[name="select_gift_images"]:checked').parent().find('.atc_cards .box-style-title').text();
                        var textInput = $('[name="gift_box_text_input"]').val();
                        var fontInput = $('[name="select_gift_text_font"]:checked').val() 
                        var colorInput = $('[name="text_color"]').val() 
                        var updateArr = [ "Image - "+imageInput, "Title - "+textInput, "Font - "+fontInput,  "Color - "+colorInput];
                        $('.bxp-step-box-imgs .bxp-summary-container[data-sort="3"] .bxp-summary-img').attr('src', imageInput   );
                        $('.bxp-step-box-imgs .bxp-summary-container[data-sort="3"] div').html(imageName + ' <span class="bxp-right">x1</span>'); 

                        var newData = JSON.parse(JSON.stringify(sec_sub_value));
                        updateObject("product_options", updateArr, newData);
                         
                        temp_card_data.push(newData);
                    });
                }
            }
        });
    });

    var existingEntries = JSON.parse(localStorage.getItem(dynamicVari) || '[]');
    temp_cart_data = existingEntries
    temp_cart_data['tab_3'] = temp_card_data;
    localStorage.setItem(dynamicVari, JSON.stringify(temp_cart_data));
  }


  $(document).ready(function() {
      var path = window.location.pathname;
      var current_handle = document.getElementById("giftjs_extension").getAttribute("page_handle");
      var page_content = document.getElementById("giftjs_extension").getAttribute("page_content");
      if(page_content=='gbb_page_auto_generated' || current_handle == 'gift-box-builder')
      {
        $("body").append('<style>*{box-sizing:border-box}body{margin:0;padding:0}img{max-width:100%;height:auto;vertical-align:middle}.gift-demo-section{width:100%;max-width:1200px;margin:0 auto;padding:0 15px}.gift-demo-row{display:flex;flex-wrap:wrap;gap:25px;justify-content:center}.gift-demo-col{width:calc(50% - 25px/2);background-color:#fff;border:1px solid #dbd7d8;padding:15px}.font-box-col,.img-thumb-col{width:calc(25% - 10px*3/4);padding:7px;box-shadow:0 0 3px rgba(0,0,0,.2);position:relative}.gift-demo-col.gift-demo-left{display:flex;justify-content:center;align-items:center}.img-thumb-row{display:flex;flex-wrap:wrap;gap:10px;margin-bottom:25px}.img-thumb-col{display:flex;justify-content:center;align-items:center;border-radius:3px}.img-thumb-col img{max-width:90%}.gift-demo-left .demo-title,.gift-demo-modal .demo-title{position:absolute;color:#730909;font-size:26px;font-weight:700;}.gift-demo-title{font-size:15px;margin:10px 0;font-weight:600;letter-spacing:0;line-height:normal;color:#000}.gift-demo-box textarea{width:100%;border:1px solid #d6d6d6;padding:10px 20px;outline:0;border-radius:3px;box-shadow:inherit;resize:none;font-size:14px}.font-box-row{display:flex;flex-wrap:wrap;gap:10px}.font-box-col,.preview-btn a{display:flex;justify-content:center}.font-box-col{align-items:center;min-height:130px;border-radius:3px}.font-box-col input:checked+label:before,.img-thumb-col input:checked+label:before{border:1px solid #1350de;position:absolute;left:0;top:0;height:100%;width:100%;border-radius:3px;content:""}.font-box-col input:checked+label:after,.img-thumb-col input:checked+label:after{background:url(https://cdn.shopify.com/s/files/1/0736/7871/7225/t/2/assets/check_right.png) right bottom no-repeat;content:"";width:18px;height:18px;position:absolute;bottom:0;right:0}.font-box-col input,.img-thumb-col input{position:absolute;opacity:0}.gift-demo-title .small-title{display:block;margin-top:10px;font-size:14px;margin-bottom:10px}.gift-demo-title input[type=color]{padding:0;margin:0;border:0;width:40px;height:40px;border-radius:5px;cursor:pointer}.preview-btn a{background-color:#730909;color:#fff;height:43px;align-items:center;padding:0 20px;min-width:320px;max-width:fit-content;border-radius:25px;text-decoration:none}.preview-btn a:hover{background-color:#a10d0d}.modal-box{display:none;position:fixed;z-index:9999;padding-top:100px;left:0;top:0;width:100%;height:100%;overflow:auto;background-color:rgba(0,0,0,.4)}.gift-demo-modal{width:100%;background-color:#fff;border:1px solid #dbd7d8;padding:15px;display:flex;justify-content:center;align-items:center}.modal-box-content{background-color:#fefefe;margin:auto;padding:20px;border:1px solid #888;width:40%}.close-box{color:#aaa;float:right;font-size:28px;font-weight:700}.close-box:focus,.close-box:hover{color:#000;text-decoration:none;cursor:pointer}.font-box-col label:before,.img-thumb-col label:before{z-index:2;position:absolute;content:"";height:100%;width:100%;top:0;left:0}.body_bg_color{background:#f9ecec;padding:40px 0}.gift-demo-title span{color:red}.img-thumb-col label{text-align:center}.gift-demo-right .top_padding_title{margin-top:20px}.hrgntl_line{height:1px;width:100%;display:inline-block;background:#d7d7d7;margin:11px 0 0}@media only screen and (max-width:991px){.font-box-col{min-height:100px}}@media only screen and (max-width:767px){.preview-btn a{min-width:100%}.gift-demo-col{width:100%}.font-box-col{min-height:100px}}</style>');
        //const myInterval = setInterval(myTimer, 5000);
        function appendCardCustom()
        {
            /*if($('.qe_gidt_box_builder #tab-3').hasClass('active') == true)
            {
                clearInterval(myInterval);
            }*/
            var gift_view_image_html = '<form class="body_bg_color" action="" >' +
            '  <div class="gift-demo-section">' +
            '    <div class="gift-demo-row">' +
            '      <div class="gift-demo-col gift-demo-left" id="gift_box_div">' +
            '        <img src="" id="gift_box_image">' +
            '        <div class="demo-title" id="gift_box_text" style="width: 400px;word-wrap: break-word; line-height: 42px; margin-top: 210px;"><div id="gift_box_text_sub" style="font-size: 40px; line-height: 42px; display: flex; justify-content: center; width: 100%; height: 304px; align-items: center;"><span style="max-width:100%">Gift Box Demo</span></div></div>' +
            '      </div>' +
            '      <div class="gift-demo-col gift-demo-right">' +
            '        <div class="gift-demo-title">Escolha o Padrao <span>*</span></div>' +
            '        <div class="img-thumb-row">' +
            '        </div>' +
            '        <div class="gift-demo-title">Escreva a sua mensagem personalizada <span>*</span></div>' +
            '        <div class="gift-demo-box">' +
            '          <textarea maxlength="500" id="gift_box_text_input" name="gift_box_text_input" rows="4" cols="50">Gift Box Demo</textarea>' +
            '        </div>' +
            '        <div class="gift-demo-title">Select font <span class="small-title"></span></div>' +
            '        <div class="font-box-row">' +
            '          <div class="font-box-col">' +
            '            <input type="radio" id="select_font1" name="select_gift_text_font"' +
            '              checked="checked" value="Bitter" />' +
            '            <label for="select_font1"><img src="https://cdn.shopify.com/s/files/1/0726/5350/4835/files/Bitter.png?v=1695903437" width="150" height="50"></label>' +
            '          </div>' +
            '          <div class="font-box-col">' +
            '            <input type="radio" id="select_font2" name="select_gift_text_font" value="Poppins" />' +
            '            <label for="select_font2"><img src="https://cdn.shopify.com/s/files/1/0726/5350/4835/files/Poppins.png?v=1695903436" width="150" height="50"></label>' +
            '          </div>' +
            '          <div class="font-box-col">' +
            '            <input type="radio" id="select_font3" name="select_gift_text_font" value="Montserrat" />' + 
            '            <label for="select_font3"><img src="https://cdn.shopify.com/s/files/1/0726/5350/4835/files/Montserrat.png?v=1695903437" width="150" height="50"></label>' +
            '          </div>' +
            '        </div>' +
            '        <div class="gift-demo-title small-title top_padding_title">Select color' +
            '          <span class="small-title"></span>' +
            '          <input type="color" id="text_color" name="text_color" value="#730909">' +
            '        </div>' +
            '        <div class="hrgntl_line">&nbsp;</div>' +
            '        <div class="preview-btn">' +
            '          <a href="javascript:void(0);" id="preview_btn">Preview</a>' +
            '        </div>' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</form>' +
            '<div id="myModalBox" class="modal-box">' +
            '  <div class="modal-box-content">' +
            '    <span class="close-box">&times;</span>' +
            '    <div class="gift-demo-modal" id="put_modal_box"></div>' +
            '  </div>' +
            '</div>';
            $('.qe_gidt_box_builder #tab-3').append('<div id="gift_view_image_html"></div>');
            $("#gift_view_image_html").html(gift_view_image_html);
          
            var get_main_class = $('.qe_gidt_box_builder #tab-3').find('ul.card-list li');
            var first_image = '';
            $(get_main_class).each(function( index ) {
              var c_image = $(this).find('.gift-card img').attr('src');
              if(c_image==''){
                c_image = $(this).find('.gift-card img').attr('data-src');
              }
              if(first_image == '')
              {
                first_image = c_image;
              }
              
              var show_checked = '';
              if(index == 0)
              {
                show_checked = 'checked="checked"';
              }
              var c_details = $(this).find('.box-style-details').html();
              var append_cards =  '<div class="img-thumb-col">' +
              '            <input type="radio" id="select_image'+index+'" name="select_gift_images"  value="'+c_image+'" />' +
              '            <label for="select_image'+index+'"><img src="'+c_image+'"></label>' +
              '            <div style="display:none;" class="atc_cards">'+c_details+'</div>'+
              '          </div>';
              $('.img-thumb-row').append(append_cards);
          });
          $('.gift-demo-left img').attr("src",first_image); 
          $('.qe_gidt_box_builder #tab-3').find('ul.card-list').hide();
        }
        
        $(document).on("click", "input[name='select_gift_images']", function() {
            $('#giftbox-custom-toast').remove();
            var this_val = $(this).val();
            $("#gift_box_image").attr("src", this_val);
            //$('.bxp-summary-container span[data-product-tab="tab_3"]').parent().remove();
           
            $(this).parent().find('.atc_cards a.add_to_temp_bucket')[0].click();
            if($('input[name="select_gift_images"]:selected').length == 0){
              $('input[name="select_gift_text_font"]').eq(0).click();
            }

            updateCart();
        });

        $(document).on('click','.btn_navigation',function()
        {
            var currentActiveSectionId = Number($(".tabs section.active").attr("id").split("-").pop());
            if(currentActiveSectionId==2 && $('#gift_view_image_html').length ==0 ){
              appendCardCustom();
            }
            if(currentActiveSectionId==3){
              updateCart();
              if($('.bxp-step-box-imgs .bxp-summary-container[data-sort="3"]').length==1){
                getBase64FromImageUrl();
              }
            }
          
        });

        
        function getBase64FromImageUrl() {
            var card_media_link = $('#gift_box_image').attr('src');
            if(card_media_link){
              card_media_link = card_media_link.split('/');
              var card_media_link = card_media_link[card_media_link.length - 1];
              var card_image = 'https://cdn.shopify.com/s/files/1/0726/5350/4835/t/2/assets/'+card_media_link;
              var card_text = $('textarea[name="gift_box_text_input"]').val();
              var currentTextLength = card_text.length;
              var font_size = "50px ";
              var line_height = "42px";
              var heightPlus = "100";
              
              if(currentTextLength >= 50 && currentTextLength <= 99){
                font_size = "45px ";
                line_height = "36px";
                heightPlus = "130";
              }else if(currentTextLength >= 100 && currentTextLength <= 149){
                font_size = "40px ";
                line_height = "34px";
                heightPlus = "110";
              }else if(currentTextLength >= 150 && currentTextLength <= 199){
                font_size = "35px ";
                line_height = "32px";
                heightPlus = "90";
              }else if(currentTextLength >= 200 && currentTextLength <= 399){
                font_size = "30px ";
                line_height = "30px";
                heightPlus = "50";
              }else if( currentTextLength > 400){
                font_size = "25px ";
                line_height = "28px";
                heightPlus = "10";
              }else{
                font_size = "50px ";
                line_height = "42px";
                heightPlus = "150";
              }

              
              var card_font = $('input:radio[name="select_gift_text_font"]:checked').val();
              var card_font_color = $('input[name="text_color"]').val();
            
              var img = new Image();
              img.crossOrigin = "*";
              img.src = card_image;
              img.onload = function () { 
                
                  function wrapText(context, text, x, y, maxWidth, lineHeight) {
                    var words = text.split(' ');
                    var line = ''; 
                    for(var n = 0; n < words.length; n++) {
                      var testLine = line + words[n] + ' ';
                      var metrics = context.measureText(testLine);
                      var testWidth = metrics.width;
                      if (testWidth > maxWidth && n > 0) {
                        context.fillText(line, x, y);
                        line = words[n] + ' ';
                        y += lineHeight;
                      }
                      else {
                        line = testLine;
                      }
                    }
                    context.fillText(line, x, y);
                  }
                
                  var canvas = document.createElement("canvas");
                  canvas.width = this.width;
                  canvas.height = this.height;
            
                  var ctx = canvas.getContext("2d");
                  ctx.clearRect(0,0,canvas.width,canvas.height);
                  ctx.drawImage(this, 0, 0);
                  ctx.font = '700 '+font_size + card_font;
                  ctx.fillStyle = card_font_color;
                  ctx.textBaseline = "middle";
                  ctx.textAlign = "center";
                
                  var maxWidth = 800;
                  var lineHeight = 60;
                  var x = canvas.width / 2;
                  var y = canvas.height/2;
                  wrapText(ctx, card_text, x, parseInt( y + parseInt(heightPlus)), maxWidth, lineHeight);
                  var dataURL = canvas.toDataURL("image/jpg");
                  var dataURLAfter = dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
                  console.log(dataURLAfter);
                
                  localStorage.setItem("gbb_canvas_image", dataURLAfter);
              };
            }
        }

         var textLength = 0;
        $(document).on("keyup", "#gift_box_text_input", function() {
           var currentTextLength = $('#gift_box_text_sub span').text().length;
           var this_val = $(this).val();
           $("#gift_box_text #gift_box_text_sub span").html(this_val);
            
            if(currentTextLength >= 50 && currentTextLength <= 99){
              $('#gift_box_text #gift_box_text_sub').css('font-size', "35px" );
              $('#gift_box_text #gift_box_text_sub').css('line-height', "40px" );                
            }else if(currentTextLength >= 100 && currentTextLength <= 149){
              $('#gift_box_text #gift_box_text_sub').css('font-size', "30px" );
              $('#gift_box_text #gift_box_text_sub').css('line-height', "40px" );
            }else if(currentTextLength >= 150 && currentTextLength <= 199){
              $('#gift_box_text #gift_box_text_sub').css('font-size', "25px" );
              $('#gift_box_text #gift_box_text_sub').css('line-height', "35px" );
            }else if(currentTextLength >= 200 && currentTextLength <= 399){
              $('#gift_box_text #gift_box_text_sub').css('font-size', "20px" );
              $('#gift_box_text #gift_box_text_sub').css('line-height', "30px" );
            }else if( currentTextLength > 400){
              $('#gift_box_text #gift_box_text_sub').css('font-size', "15px" );
              $('#gift_box_text #gift_box_text_sub').css('line-height', "28px" );
            }else{
              $('#gift_box_text #gift_box_text_sub').css('font-size', "40px" );
              $('#gift_box_text #gift_box_text_sub').css('line-height', "42px" );
            }
         
        });
         
        $(document).on("click", "input[name='select_gift_text_font']", function() {
            var this_val = $(this).val();
            $("#gift_box_text").css("font-family", this_val);
        });
        
        $(document).on("input", "#text_color", function() {
            var this_val = $(this).val();
            $("#gift_box_text").css('color', this_val);
        });
        
        $(document).on("click", "#preview_btn", function() {
            var modalbox = document.getElementById("myModalBox");
            var gift_box_div = $("#gift_box_div").html();
            $("#put_modal_box").html(gift_box_div);
            modalbox.style.display = "block";
          
            $(document).find('#page-transition-overlay').remove();
            $('.gift-demo-modal #gift_box_text').css("top","auto");
        });
        
        $(document).on("click", ".close-box", function() {
            var modalbox = document.getElementById("myModalBox");
            modalbox.style.display = "none";
          
            $(document).find('#page-transition-overlay').remove();
           // $('.demo-title').css("top","55%");
        });

        window.onclick = function(event) {
            var modalbox = document.getElementById("myModalBox");
            if (event.target == modalbox) {
                modalbox.style.display = "none";
            }
           // $('.demo-title').css("top","55%");
        }
      }
    
  });
 
});                                     